/**
 * @flow
 * @relayHash e027eca42c9dd646c6d5894404010744
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type savePickemAnswerInput = {|
  pickemAnswerInput?: ?pickemAnswerInputType,
  clientMutationId?: ?string,
|};
export type pickemAnswerInputType = {|
  id?: ?string,
  event_id: string,
  game_id: string,
  guest_id: string,
  question_id: string,
  quarter_id: string,
  is_correct_answer?: ?boolean,
  is_tiebreaker?: ?boolean,
  answer?: ?string,
|};
export type savePickemAnswerMutationVariables = {|
  input: savePickemAnswerInput
|};
export type savePickemAnswerMutationResponse = {|
  +savePickemAnswer: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?{|
      +_id: ?number,
      +correct_answer_count: ?number,
      +questions_answered: ?number,
    |},
  |}
|};
export type savePickemAnswerMutation = {|
  variables: savePickemAnswerMutationVariables,
  response: savePickemAnswerMutationResponse,
|};
*/


/*
mutation savePickemAnswerMutation(
  $input: savePickemAnswerInput!
) {
  savePickemAnswer(input: $input) {
    code
    message
    data {
      _id
      correct_answer_count
      questions_answered
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "savePickemAnswerInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "savePickemAnswer",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "savePickemAnswerPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "data",
        "storageKey": null,
        "args": null,
        "concreteType": "pickemMutationReturnDataType",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "correct_answer_count",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "questions_answered",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "savePickemAnswerMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "savePickemAnswerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "savePickemAnswerMutation",
    "id": null,
    "text": "mutation savePickemAnswerMutation(\n  $input: savePickemAnswerInput!\n) {\n  savePickemAnswer(input: $input) {\n    code\n    message\n    data {\n      _id\n      correct_answer_count\n      questions_answered\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '69e799352d463b69ad205d76e88e89f7';
module.exports = node;
